var _rect, _path, _path2, _g, _g2, _g3, _g4, _text, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummerSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 200,
    viewBox: "0 0 800 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 200,
    rx: 10,
    fill: "#FFECB3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30 L800 30",
    stroke: "#FF9800",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 170 L800 170",
    stroke: "#FF9800",
    strokeWidth: 2,
    strokeDasharray: "6 4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80, 90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 30,
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -45 L0 -35",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45 L0 35",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-45 0 L-35 0",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45 0 L35 0",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 -32 L-25 -25",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 32 L25 25",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-32 32 L-25 25",
    stroke: "#FFC107",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 -32 L25 -25",
    stroke: "#FFC107",
    strokeWidth: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(720, 100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L0 60",
    stroke: "#8D6E63",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L-40 -30",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 -30 L-50 -20",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40 -30 L-45 -40",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L20 -40",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -40 L35 -40",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 -40 L15 -55",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L-30 -10",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30 -10 L-45 0",
    stroke: "#4CAF50",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30 -10 L-40 -20",
    stroke: "#4CAF50",
    strokeWidth: 5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 130)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20 0 A20 20 0 0 0 20 0",
    fill: "#FF5252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 -20 A20 20 0 0 0 0 20",
    fill: "#2196F3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(650, 60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-30 0 L30 0",
    stroke: "black",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -15,
    cy: 0,
    r: 12,
    fill: "#333"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 0,
    r: 12,
    fill: "#333"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 80,
    fontFamily: "Arial, sans-serif",
    fontSize: 40,
    fontWeight: "bold",
    fill: "#FF9800",
    textAnchor: "middle"
  }, "SUMMER SALE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 120,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fill: "#FF9800",
    textAnchor: "middle"
  }, "15% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fill: "#333",
    textAnchor: "middle"
  }, "Beat the heat with cool discounts! Limited time offer.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummerSale);
export default __webpack_public_path__ + "static/media/summer_sale.03f93fc61f9737444637f544d593b332.svg";
export { ForwardRef as ReactComponent };